import { render, staticRenderFns } from "./articleSelector.vue?vue&type=template&id=f13ec592&scoped=true"
import script from "./articleSelector.vue?vue&type=script&lang=js"
export * from "./articleSelector.vue?vue&type=script&lang=js"
import style0 from "./articleSelector.vue?vue&type=style&index=0&id=f13ec592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13ec592",
  null
  
)

export default component.exports